import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function TerminosGeneralesServicio() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XX. TÉRMINOS Y CONDICIONES GENERALES DEL SERVICIO</h4>
          <br></br>
          <p>
            Por la seguridad del vehículo, Parking le solicita tener en cuenta las siguientes condiciones de prestación del servicio:
          </p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <p>Estacionar en posición de salida</p>
            </li>
            <li>
              <p>Cerrar el vehículo con la alarma activada</p>
            </li>
            <li>
              <p>Solicitar inventario escrito del estado exterior del vehículo</p>
            </li>
            <li>
              <p>Para mayor seguridad de su bien Parking le recomienda asegurar debidamente su vehículo y no dejar objetos personales ni de valor dentro del mismo</p>
            </li>
            <li>
              <p>No deje objetos personales dentro de su vehículo toda vez que Parking no se hace responsable por su posible pérdida, robo o custodia. En todo caso, en cumplimiento del numeral 3 del artículo 90 del código de policía, usted podrá relacionarlos en el formato disponible en el punto de pago. No obstante Parking no es responsable de los objetos relacionados.</p>
            </li>
            <li>
              <p>Efectuar reclamo en caso de presentarse alguna inconsistencia antes de retirar el vehículo del parqueadero.</p>
            </li>
          </ul>

          <p style={{ fontWeight: 'bold' }}>Procedimiento de reclamación:</p>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>Presentar el comprobante de ingreso.</p>
            </li>
            <li>
              <p>Diligenciar el formato denominado “Informe de Accidente y/o Servicio al Cliente” y entregárselo al operario.</p>
            </li>
            <li>
              <p>Conservar las pruebas y facilitar las investigaciones de Parking, la aseguradora o las autoridades competentes.</p>
            </li>
            <li>
              <p>Proporcionar la documentación requerida.</p>
            </li>
            <li>
              <p>Atender el procedimiento e instrucciones impartidas por el personal de Parking.</p>
            </li>
            <li>
              <p>Compartir la información personal necesaria para la atención del siniestro.</p>
            </li>
            <li>
              <p>Autorizar el uso de sus datos personales conforme a lo establecido en la Política de Privacidad de Parking International S.A.S., la cual se encuentra disponible en la página web.</p>
            </li>
          </ol>
          <p>
            Parking International S.A.S. dará respuesta dentro de los términos establecidos por la ley y, en caso de ser positiva, indicará los pasos a seguir.
          </p>
          <p>
            Recuerde que, en caso de daños ocasionados por fuerza mayor, caso fortuito, incendio, asonada, terrorismo o actos cometidos por terceros, deberá informarse de inmediato a la Empresa y a las autoridades correspondientes.
          </p>
          <p>
            El vehículo será entregado en las mismas condiciones registradas al momento del ingreso, salvo que presente daños mecánicos, eléctricos u otros no atribuibles a nuestro servicio. Para retirar el vehículo, deberá presentar el comprobante de ingreso y realizar el pago correspondiente por el servicio.
          </p>
          <p>
            El Usuario deberá cuidar el ticket de entrada. Su perdida debe ser denunciadas ante las autoridades y ocasiona el pago del valor de la reposición. Este tendrá un costo adicional a la tarifa del parqueadero.
          </p>
          <p>
            Nuestro servicio está amparado por póliza de seguro R.C.E.            
          </p>
        </Col>
      </Row>
    </Container>
  );
}